<!-- Header above table -->
<div class="w-100 mb-1 table-top-container clearfix">
  <div class="top-left-container form-inline">
    <div class="page-size-container">
      <span class="hidden-sm">Show</span>
      <label class="for hidden-md-plus">Page length:</label>
      <select (change)="pageSizeSource.next($event.target.value)" class="form-control mx-sm-1">
        @for (length of pageLengths; track length) {
          <option
            aria-label="Table page length"
            [selected]="pageSizeSource.value === length"
            >
            {{ length }}
          </option>
        }
      </select>
      <span class="hidden-sm">entries</span>
    </div>
    <div class="top-left-container form-inline">
      <div class="d-flex align-items-start">
        <div id="notMobile" class="btn-container hidden-sm">
          <pcg-button-hide-show class="hidden-sm" [columnDefs]="columnDefs"></pcg-button-hide-show>
          @if (filterId) {
            <pcg-button-filter
              id="pcg-button-filter"
              class="ml-1 hidden-sm"
              [filterId]="filterId"
            ></pcg-button-filter>
          }
          @if (showResetFilterBtn()) {
            <pcg-button-reset-filter
              class="ml-1 hidden-sm"
            ></pcg-button-reset-filter>
          }
        </div>
      </div>
    </div>

    @if (filterMap && btnFilterService.getActiveFilters(ajaxData, filterMap)) {
      <div>
        <div
          class="applied-filters top-left-container form-inline alert-success d-flex flex-row align-items-start form-control-sm"
          role="alert"
          >
          Applied Filters: {{ btnFilterService.getActiveFilters(ajaxData, filterMap) }}
        </div>
      </div>
    }
  </div>

  @if (canGlobalSearch) {
    <div class="search-container form-inline">
      <div class="exact-match-container">
        <div class="form-check form-check-inline">
          <label [for]="'exactMatch' + uniqueId" class="form-check-label mr-2">Exact Match</label>
          <input
            [id]="'exactMatch' + uniqueId"
            type="checkbox"
            class="form-check-input"
            (change)="exactMatchSource.next($event.target.checked)"
            />
          </div>
        </div>
        <div class="order-first order-md-last">
          <div class="hidden-md-plus">
            <label class="for">Search:</label>
          </div>
          <input
            aria-label="Table search"
            type="search"
            class="form-control"
            placeholder="Search..."
            (keyup)="filterSource.next($event.target.value)"
            (click)="clearSearch($event)"
            />
          </div>
        </div>
      }
      <div class="btn-container hidden-md-plus">
        <pcg-button-hide-show [columnDefs]="columnDefs"></pcg-button-hide-show>
      </div>
    </div>
